import React from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import circle from "../../../../assets/DigitalMarketing/image/dashboard/circle_down.svg";

function ChartBox(props) {
  const {element,title} = props;
  return (
    <div className="cards h-100">
      <div className="d-flex justify-content-between">
        <h3 className="f-10 fw-300">{title}</h3>
        {/* <span>
          This week <img src={circle} alt="i" />
        </span> */}
        {/* <BsThreeDotsVertical className="c-blue cursur"/> */}
      </div>
      <div>
        {element}
      </div>      
    </div>
  );
}

export default ChartBox;
